import { ApiSlugs, ListPagination, PlanDto, PlanId } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class PlansAdminConnector extends ApiConnector<PlanDto, PlanDto, PlanId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.PLANS);
  }

  summarized = () => ({
    list: (pagination?: ListPagination): Observable<PlanDto[]> =>
      this.apiCaller.getRequest<PlanDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
